import { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Header from '../components/Header/Header';
import Sidebar from '../components/Sidebar/Sidebar'

const  DefaultLayout = () => {
	const [screenWidth, setScreenWidth] = useState(window.innerWidth)
	const [showSidebar, setShowSidebar] = useState(true)

	// screen breakpoint
	const breakpoint = 820

	// Get location for use in Header component
	const location = useLocation()
	const getWordsFromLocation = location.pathname === '/' ? 'Overview' : location.pathname.replace(/[^a-zA-Z]/g, " ")
	const headerText = getWordsFromLocation.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());

	const sidebarRef = useRef()
	const toggleRef = useRef();

	useEffect(() => {
		// Set screen width as window resizes
		const handleWindowResize = () => { setScreenWidth(window.innerWidth) }
		window.addEventListener('resize', handleWindowResize)

		if (screenWidth > breakpoint) {
			setShowSidebar(true)
		} else {
			setShowSidebar(false)
		}
		// Remove event listener
		return () => window.removeEventListener('resize', handleWindowResize)
	}, [screenWidth])


	useEffect(() => {
		const openSidebar = (e) => {
			if (toggleRef.current === e.target) setShowSidebar(!showSidebar)
		}
		const closeSidebar = (e) => {
			if (screenWidth < breakpoint) {
				if (sidebarRef.current && !sidebarRef.current.contains(e.target) && showSidebar === true) {
					setShowSidebar(false)
				}
			}
		}
		window.addEventListener("click", closeSidebar)
		window.addEventListener("click", openSidebar)

		return () => {
			window.removeEventListener('click', closeSidebar)
			window.removeEventListener('click', openSidebar)
		}
	}, [showSidebar, screenWidth])

	return (
		<div>
			{showSidebar && <Sidebar forwardRef={sidebarRef} />}
			
			<Header title={headerText} forwardRef={toggleRef} />
			<div className='main-screen'>
				<Outlet />
			</div>
		</div>
	);
};

export default DefaultLayout;
